import React from "react"

import SystemConfigurationInput from "components/Configurations/SystemConfigurationInput"

import {
	DispatchProductDetailPageReducer,
	ProductDetailPageReducerState,
	setSelectedSystem,
} from "@secureo/common/reducers/productDetailPageReducer"

const SystemConfiguration = ({ isLoading, dispatch, reducerState, accessToken }: Props) => {
	const {
		selectedSystem,
		attributes: { systems, systemConfigurationToolTip },
	} = reducerState

	const onSystemChange = (selectedSystem: string) => {
		setSelectedSystem(accessToken, dispatch, reducerState, selectedSystem)
	}

	return (
		<SystemConfigurationInput
			systems={systems}
			selectedSystem={selectedSystem}
			onSystemChange={onSystemChange}
			disabled={isLoading || !accessToken}
			systemConfigurationToolTip={systemConfigurationToolTip}
		/>
	)
}

interface Props {
	isLoading: boolean
	dispatch: DispatchProductDetailPageReducer
	reducerState: ProductDetailPageReducerState
	accessToken: string
}

export default SystemConfiguration
